import { useEffect, useState } from 'react';
import { useErrorReport } from '../../../contexts/ErrorReportContext';
import { getArtistByClaimedUid } from '../../../services/artists/artistsApi';

/**
 * @param {string|null|undefined} uid
 * @returns {{ artist: object|null, loading: boolean }}
 */
export default function useClaimedArtist(uid) {
  const { reportError } = useErrorReport();
  const [artist, setArtist] = useState(null);
  const [loading, setLoading] = useState(Boolean(uid));

  useEffect(() => {
    const owner = String(uid || '').trim();
    if (!owner) {
      setArtist(null);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    getArtistByClaimedUid(owner)
      .then((row) => {
        if (!cancelled) {
          setArtist(row);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setArtist(null);
          setLoading(false);
          reportError(err, {
            pageLabel: 'Artists',
            source: 'artists-claim-lookup',
            silent: true,
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [uid, reportError]);

  return { artist, loading };
}
